import {
  setRequestPM,
  broadcastPlayerMessagePM,
  broadcastCursorFromActionPM
} from "./redux/actions/index";

/* Public Methods Available For LRoot */
function Root(Base, store) {
  class NewRoot extends Base {

    partymode_song_request(deck, track) {
      store.dispatch(setRequestPM({ deck, track }));
    }
    partymode_send_message(message) {
      store.dispatch(broadcastPlayerMessagePM(message));
    }
    partymode_cursor_action(keyAction) {
      const isEnable = store.getState()['enablePM'];
      const isWatcher = store.getState()['isWatcherPM'];
      if (isEnable) {
        if (!isWatcher) {
          store.dispatch(broadcastCursorFromActionPM(keyAction));
        } else {
          if (window['pm-warning']) { window['pm-warning'](null); }
        }
        return !isWatcher;
      } else {
        return true; // DEFAULT ACTIVE;
      }
    }
  }
  return NewRoot;
}

export default Root;
